'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('../../components');

var _iconsComponents = require('../../icons-components');

var _containers = require('../../containers');

var _buttons = require('@sitebase/ui-kit/es/buttons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ErrorMessage component.
 * @param {WithTranslationsPropsType} props element
 * @returns {ReactElement} React element
 */

var ErrorMessage = function ErrorMessage(_ref) {
  var dividerText = _ref.dividerText,
      footerChatButton = _ref.footerChatButton,
      footerHelpTitle = _ref.footerHelpTitle,
      genericErrorMessage = _ref.genericErrorMessage,
      genericErrorTitle = _ref.genericErrorTitle,
      onChatButtonClick = _ref.onChatButtonClick,
      onRetry = _ref.onRetry,
      retryButtonText = _ref.retryButtonText,
      showOtherMethods = _ref.showOtherMethods;
  return _react2.default.createElement(
    'div',
    { className: 'qd-error-screen__container' },
    _react2.default.createElement(
      'div',
      { className: 'qd-error-screen__main-panel' },
      _react2.default.createElement(
        'section',
        { className: 'qd-error-screen__error' },
        _react2.default.createElement(
          'div',
          { className: 'qd-error-screen__error-icon' },
          _react2.default.createElement(_iconsComponents.ErrorIcon, null)
        ),
        _react2.default.createElement(
          'h2',
          { className: 'qd-error-screen__error-title' },
          genericErrorTitle
        ),
        _react2.default.createElement('span', {
          className: 'qd-error-screen__error-message-subtitle',
          dangerouslySetInnerHTML: { __html: genericErrorMessage }
        })
      ),
      _react2.default.createElement(
        'section',
        { className: 'qd-error-screen__action-panel' },
        _react2.default.createElement(
          'div',
          { className: 'qd-error-screen__try-again' },
          _react2.default.createElement(
            _buttons.Button,
            { outfit: 'quaternary large expanded', onClick: onRetry, 'data-test-id': 'qd__try-again' },
            retryButtonText
          )
        ),
        showOtherMethods && _react2.default.createElement(
          'div',
          { className: 'qd-error-screen__other-methods' },
          _react2.default.createElement(
            _components.Divider,
            null,
            dividerText
          ),
          _react2.default.createElement(_containers.OtherMethodsContainer, null)
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'qd-error-screen__help-panel' },
      _react2.default.createElement(
        'span',
        { className: 'qd-error-screen__help-title' },
        footerHelpTitle
      ),
      _react2.default.createElement(
        'div',
        { className: 'qd-error-screen__help-buttons' },
        _react2.default.createElement(_components.HelpButton, { icon: _react2.default.createElement(_iconsComponents.ChatIcon, null), onClick: onChatButtonClick, testId: 'qd__help-chat', text: footerChatButton })
      )
    )
  );
};

exports.default = ErrorMessage;